import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Calendar, ArrowRight, Mail } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function ThankYou() {
  useEffect(() => {
    // Fire GA conversion event when the thank-you page loads.
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "assessment_thank_you_view", {
        event_category: "lead",
        event_label: "assessment",
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#EDF1FB]">
      <Navbar variant="solid" />
      <section className="pt-[140px] pb-24 px-6">
        <div
          data-testid="thank-you-container"
          className="max-w-2xl mx-auto text-center bg-white rounded-3xl p-10 md:p-14 border border-[#E2E8F4] shadow-sm"
        >
          <div className="w-16 h-16 rounded-full bg-[#16C47F]/10 text-[#16C47F] flex items-center justify-center mx-auto">
            <CheckCircle2
              className="w-9 h-9"
              data-testid="thank-you-icon"
            />
          </div>
          <h1
            data-testid="thank-you-title"
            className="mt-7 text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0A1F47] leading-tight"
          >
            Got it — your request is in
          </h1>
          <p className="mt-4 text-base md:text-lg text-[#0A1F47]/70 leading-relaxed">
            A senior architect will review your submission and respond within
            one business day. While you're here, grab a 15-minute slot so we
            can dig in faster.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              data-testid="thank-you-book-call"
              href="https://calendly.com/webkbaker071"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                if (
                  typeof window !== "undefined" &&
                  typeof window.gtag === "function"
                ) {
                  window.gtag("event", "calendly_click", {
                    event_category: "lead",
                    event_label: "thank_you",
                  });
                }
              }}
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-[#2E6BF6] hover:bg-[#1E55D6] text-white font-semibold transition-colors"
            >
              <Calendar className="w-4 h-4" />
              Book a 15-min call
            </a>
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl border border-[#0A1F47]/20 hover:bg-[#F5F7FA] text-[#0A1F47] font-semibold transition-colors"
            >
              Back to Home <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="mt-10 pt-8 border-t border-[#E2E8F4] text-left">
            <h3 className="text-sm font-bold uppercase tracking-wider text-[#0A1F47]/60">
              What happens next
            </h3>
            <ol className="mt-5 space-y-4 text-sm md:text-base text-[#0A1F47]/80">
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-[#0A1F47] text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                  1
                </span>
                <span>
                  We'll email you a short intake form to share repos, Terraform
                  state, and CI/CD access.
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-[#0A1F47] text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                  2
                </span>
                <span>
                  An architect runs the 7-day audit across infra, pipelines,
                  risk, and cost.
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-[#0A1F47] text-white text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
                  3
                </span>
                <span>
                  You get a written report + 15-minute walkthrough with a
                  prioritized plan.
                </span>
              </li>
            </ol>
          </div>

          <p className="mt-8 text-sm text-[#0A1F47]/60 flex items-center justify-center gap-2">
            <Mail className="w-4 h-4" /> Questions?{" "}
            <a
              href="mailto:kween.baker@nstinstitute.com"
              className="text-[#2E6BF6] hover:underline"
            >
              kween.baker@nstinstitute.com
            </a>
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
